import { render, staticRenderFns } from "./ShippingInstructionPayments.vue?vue&type=template&id=b544cc76&scoped=true&"
import script from "./ShippingInstructionPayments.vue?vue&type=script&lang=js&"
export * from "./ShippingInstructionPayments.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInstructionPayments.vue?vue&type=style&index=0&id=b544cc76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b544cc76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b544cc76')) {
      api.createRecord('b544cc76', component.options)
    } else {
      api.reload('b544cc76', component.options)
    }
    module.hot.accept("./ShippingInstructionPayments.vue?vue&type=template&id=b544cc76&scoped=true&", function () {
      api.rerender('b544cc76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/shipping-instruction/ShippingInstructionPayments.vue"
export default component.exports